import { useOutletContext } from 'react-router-dom'

import { UpsertAllowanceDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'

import UpsertAllowance from 'modules/timeoff/components/TimeoffAllowances/UpsertAllowance'
import type { RouteContextParams } from 'modules/timeoff/lib/routeContextParams'

const EditAllowancePage = () => {
  const { policy } = useOutletContext<RouteContextParams>()
  const policyId = policy?.attributes.id
  const { allowanceId } = useStrictParams<'allowanceId'>()

  const { company } = useCurrentSession()
  const { loading: loadingQuery, data: queryData } = useQuery(UpsertAllowanceDocument, {
    variables: {
      companyId: company.id,
    },
  })

  return (
    <UpsertAllowance
      allowanceId={Number(allowanceId)}
      policyId={policyId}
      queryData={queryData}
      loadingQuery={loadingQuery}
    />
  )
}

export default EditAllowancePage
